import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const horizontalDividerRootFn = /* @__PURE__ */ createRecipe('horizontal-divider__root', {
  "color": "neutral"
}, [])

const horizontalDividerRootVariantMap = {
  "margin": [
    "0",
    "100",
    "200"
  ],
  "topMargin": [
    "0",
    "100",
    "200"
  ],
  "bottomMargin": [
    "0",
    "100",
    "200"
  ],
  "color": [
    "gradient",
    "neutral"
  ]
}

const horizontalDividerRootVariantKeys = Object.keys(horizontalDividerRootVariantMap)

export const horizontalDividerRoot = /* @__PURE__ */ Object.assign(memo(horizontalDividerRootFn.recipeFn), {
  __recipe__: true,
  __name__: 'horizontalDividerRoot',
  __getCompoundVariantCss__: horizontalDividerRootFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: horizontalDividerRootVariantKeys,
  variantMap: horizontalDividerRootVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, horizontalDividerRootVariantKeys)
  },
  getVariantProps: horizontalDividerRootFn.getVariantProps,
})